import { api } from '@creditsights/api-ui-web';
import { FEED_BATCH_SIZE } from '../../Base.constants';
import { Article, Region } from '../../models';
import { ArticleDto } from '../dtos/article/article.dto';
import { ArticleComponentDto } from '../dtos/article/articleComponent.dto';
import { ArticleListDto } from '../dtos/article/articleList.dto';
import { SearchFeedRequestBodyDto } from '../dtos/article/searchFeedRequestBody.dto';
import { FetchArticlesParams } from './articles.models';

export const feedsModuleV1Uri = '/common/v1/feeds';

export const fetchArticles = async ({
  take = FEED_BATCH_SIZE,
  page = 0,
  filters = {},
}: FetchArticlesParams): Promise<ArticleListDto> => {
  const params = {
    skip: page * take,
    take,
  };
  const { data } = await api.post<ArticleListDto>(`${feedsModuleV1Uri}/global`, filters, { params });
  return data;
};

export const fetchMyFeedArticles = async ({
  take = FEED_BATCH_SIZE,
  page = 0,
  filters = {},
}: FetchArticlesParams): Promise<ArticleListDto> => {
  const params = {
    skip: page * take,
    take,
  };
  const { data } = await api.post<ArticleListDto>(`${feedsModuleV1Uri}/my_cs`, filters, { params });
  return data;
};

export const fetchArticle = async (
  articleId: number,
  confirmQuotaUse: boolean,
  confirmLoanWaiver: boolean
): Promise<ArticleDto> => {
  const { data } = await api.get<ArticleDto>(
    `${feedsModuleV1Uri}/articles/${articleId}?confirmQuotaUse=${confirmQuotaUse}&confirmLoanWaiver=${confirmLoanWaiver}`
  );
  return data;
};

export const fetchMorningCommentaries = async (region: Region, take: number): Promise<Article[]> => {
  const resp = await api.get(`${feedsModuleV1Uri}/morning_comment?region=${region}&take=${take}`);
  return resp.data.results;
};

export const fetchResearchSearch = async (requestBody: SearchFeedRequestBodyDto, page = 0): Promise<ArticleListDto> => {
  const { data } = await api.post<ArticleListDto>(`${feedsModuleV1Uri}/search/research`, {
    ...requestBody,
    skip: page * requestBody.take!,
  });
  return data;
};

export const fetchCovenantsSearch = async (
  requestBody: SearchFeedRequestBodyDto,
  page = 0
): Promise<ArticleListDto> => {
  const { data } = await api.post<ArticleListDto>(`${feedsModuleV1Uri}/search/covenants`, {
    ...requestBody,
    skip: page * requestBody.take!,
  });
  return data;
};

export const fetchNewsSearch = async (requestBody: SearchFeedRequestBodyDto, page = 0): Promise<ArticleListDto> => {
  const { data } = await api.post<ArticleListDto>(`${feedsModuleV1Uri}/search/news`, {
    ...requestBody,
    skip: page * requestBody.take!,
  });
  return data;
};

export const isPdfContentComponent = async ({ file }: ArticleComponentDto): Promise<boolean> => {
  try {
    if (file?.url.endsWith('.pdf')) {
      const newUrl = file.url.startsWith('/api/') ? file.url.slice(4) : file.url;
      // Ideally it should be head request but it's not supported by the BE
      const { status, headers } = await api.get(newUrl);
      return status === 200 && headers['content-type'] === 'application/pdf';
    }
    return false;
  } catch (e) {
    return false;
  }
};
